import CaretRight from '@mds/icons/CaretRight';
import DotsNine from '@mds/icons/DotsNine';
import { useContext } from 'react';
import { useAppLayout } from '../../AppLayoutProvider';
import { AccountMenuItemButton, AccountMenuItemButtonProps } from '../AccountMenuItem';
import { AccountMenuContext } from './context';

/**
 * Built-in app switcher trigger for the account menu.
 *
 * Place this directly below `<NeonSupportCenterLink />` (or an equivalent "Support
 * center" item) in `accountMenuItems`, inside the core actions group and above any
 * per-app items or `<NeonSignOutLink />`.
 *
 * Renders nothing when `AppBarLayout`'s `appSwitcherPlacement` does not currently place
 * the app switcher trigger in the account menu (for example on wide layouts with the
 * `responsive` default, where the trigger lives in the app bar instead).
 */
export function AppSwitcherAccountMenuItem({ icon, ...rest }: Partial<AccountMenuItemButtonProps>) {
  const accountMenuContext = useContext(AccountMenuContext)!;
  const { openedAccessoryDrawer } = useAppLayout();

  if (!accountMenuContext.showAppSwitcherInAccountMenu) {
    return null;
  }

  return (
    <AccountMenuItemButton
      aria-controls="accessory-drawer-appSwitcher"
      aria-expanded={openedAccessoryDrawer === 'appSwitcher'}
      icon={icon ?? accountMenuContext.appSwitcherIcon ?? <DotsNine />}
      endIcon={<CaretRight />}
      onClick={accountMenuContext.onOpenAppSwitcherFromAccountMenu}
      {...rest}
    >
      App switcher
    </AccountMenuItemButton>
  );
}
